export default "__VITE_ASSET__ae86dad7__"